import { createSlice } from "@reduxjs/toolkit";
import { informationTabs } from "../../pages/Hub/Information/Json/InformationJson";
import {InformationFieldsJSON} from "../../pages/Hub/Information/Json/InformationFieldsJson"

const initialState = {
  tabs: informationTabs,
  activeTab: "details",
  detailsData: {},
  informationFieldJson: InformationFieldsJSON,
  
};

const agMemberSlice = createSlice({
  name: "information",
  initialState,
  reducers: {
    changeActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setInformationDetailsData: (state, action) => {
      state.detailsData = action.payload;
    },
    setInformationFieldJson(state, action) {
      state.informationFieldJson = action.payload;
    },
  },
});

export const {
  changeActiveTab,
  setInformationDetailsData,
  setInformationFieldJson,
} = agMemberSlice.actions;

export default agMemberSlice.reducer;
